<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M6.80002 1.3877C6.92931 1.3877 7.05332 1.43885 7.14474 1.53027C7.23617 1.6217 7.28732 1.74571 7.28732 1.875V5.5127H10.925C11.0543 5.5127 11.1783 5.56385 11.2697 5.65527C11.3612 5.7467 11.4123 5.87071 11.4123 6C11.4123 6.12929 11.3612 6.2533 11.2697 6.34473C11.1783 6.43615 11.0543 6.4873 10.925 6.4873H7.28732V10.125C7.28732 10.2543 7.23617 10.3783 7.14474 10.4697C7.05332 10.5612 6.92931 10.6123 6.80002 10.6123C6.67073 10.6123 6.54672 10.5612 6.45529 10.4697C6.36387 10.3783 6.31271 10.2543 6.31271 10.125V6.4873H2.67502C2.54573 6.4873 2.42172 6.43615 2.33029 6.34473C2.23887 6.2533 2.18771 6.12929 2.18771 6C2.18771 5.87071 2.23887 5.7467 2.33029 5.65527C2.42172 5.56385 2.54573 5.5127 2.67502 5.5127H6.31271V1.875C6.31271 1.74571 6.36387 1.6217 6.45529 1.53027C6.54672 1.43885 6.67073 1.3877 6.80002 1.3877Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.15"
    />
  </svg>
</template>

<script>
export default {
  name: "PlusIcon",
};
</script>
